import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import type { HttpShippingOptionDraft } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

const { CART_URL } = environment;

const SHIPPING_METHOD_URL = `${CART_URL}/shipping-methods`;

export async function updateShippingOption(
  deliveryGroupId: string,
  shippingOption: HttpShippingOptionDraft
): Promise<{ data: HttpCartDto }> {
  const expandParam =
    'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';
  const url = `${SHIPPING_METHOD_URL}/${deliveryGroupId}/option?expand=${expandParam}`;
  return await httpClient.patch(url, shippingOption);
}
